export default {
  contained: {
    color: '#CC2948',
    boxShadow: '0px 4px 15px rgb(31 33 37 / 10%)',
    backgroundColor: '#FFFFFF'
  },
  outlinedPrimary: {
    border: '1.5px solid #CC2948',
    padding: '9.5px 16px !important',
    '&:hover': {
      border: '1.5px solid #CC2948'
    }
  },
  root: {
    padding: '11px 16px !important',
    borderRadius: 6,
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  }
}
